<div class="container-fluid mt-3">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2 class="m-0">
      {{ currentEditId ? 'Update Education Induction' : 'Add Education Induction' }}
    </h2>

    <button mat-raised-button color="warn"
            (click)="onCancel()"
            type="button">
      Close
    </button>
  </div>
<!-- show full form including disabled controls during debugging -->
<!--<prettyjson [obj]="inductionForm.getRawValue()"></prettyjson>-->
  <form [formGroup]="inductionForm" autocomplete="off">
    <div class="row mb-3">
      <div class="col-md-6 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Induction For</mat-label>
          <input matInput
                 formControlName="inductionFor"
                 placeholder="Enter Trainee Name">
        </mat-form-field>
      </div>
      <div class="col-md-6 mb-3">
        <app-searchable-select
          [required]="true"
          [options]="allCenters$ | async"
          [selectedValue]="selectedInductionCentre"
          [displayWithFn]="displayCentre"
          [placeholder]="'Select Induction Centre'"
          [label]="'Select Induction Centre'"
          (selectionChange)="onInductionCentreSelect($event)"
        ></app-searchable-select>
      </div>
    </div>

    <mat-stepper [linear]="isLinear" #stepper orientation="vertical">
      <mat-step *ngFor="let day of days; let i = index" [stepControl]="getDayFormGroup(i)">
        <ng-template matStepLabel>Day {{ i + 1 }}</ng-template>
        <div class="mb-2">
          <mat-chip
            [ngClass]="{'bg-success text-white': getDayFormGroup(i).get('status')?.value === 'Done',
                         'bg-warning text-dark': getDayFormGroup(i).get('status')?.value === 'Pending'
                        }">{{ getDayFormGroup(i).get('status')?.value }}
          </mat-chip>
        </div>
        <div [formGroup]="getDayFormGroup(i)" class="row mt-3">
          <!-- Teacher Name -->
          <app-searchable-select class="col-md-6"
                                 [required]="true"
                                 [options]="allTeachers"
                                 [placeholder]="'Select Teacher Name'"
                                 [label]="'Select Teacher Name'"
                                 [selectedValue]="getDayFormGroup(i).getRawValue()?.teacherName ? { name: getDayFormGroup(i).getRawValue()?.teacherName } : null"
                                 (selectionChange)="onTeacherSelected($event, i)"
          ></app-searchable-select>

          <!-- Centre -->
          <app-searchable-select class="col-md-6"
                                 [required]="true"
                                 [options]="dayFilteredCentres[i] | async"
                                 [selectedValue]="getDayFormGroup(i).getRawValue()?.centreName ? { centreName: getDayFormGroup(i).getRawValue()?.centreName, centreCode: getDayFormGroup(i).getRawValue()?.centreCode } : null"
                                 [displayWithFn]="displayCentre"
                                 [placeholder]="'Select Centre'"
                                 [label]="'Select Centre'"
                                 (selectionChange)="onCentreSelect($event, i)"
          ></app-searchable-select>

          <!-- Session Date -->
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Session Date</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="date" placeholder="Select date">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Topic (Readonly) -->
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Topic</mat-label>
              <input matInput formControlName="topic" readonly>
            </mat-form-field>
          </div>

          <!-- Content (Textarea Readonly) -->
          <div class="col-md-12 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Content</mat-label>
              <textarea matInput rows="5" formControlName="content" readonly></textarea>
            </mat-form-field>
          </div>
          <!-- Status -->
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Status</mat-label>
              <mat-select formControlName="status">
                <mat-option value="Pending">Pending</mat-option>
                <mat-option value="Done">Done</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Suggestions & Remarks -->
          <div class="col-md-12 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Suggestions & Remarks</mat-label>
              <textarea matInput maxlength="100" rows="3" formControlName="suggestions"
                        placeholder="Enter suggestions"></textarea>
              <mat-hint align="end">
                {{ getDayFormGroup(i).get('suggestions')?.value?.length || 0 }} / 100
              </mat-hint>
            </mat-form-field>
          </div>

          <!-- Navigation Buttons -->
          <div class="col-12 d-flex justify-content-between gap-2 mt-3">
            <!-- Previous Button -->
            <button mat-raised-button color="warn" *ngIf="i > 0" matStepperPrevious type="button">
              Previous
            </button>

            <div class="ms-auto d-flex gap-2">
              <!-- Remove Button - Only show on last tab and if more than 1 day -->
              <button mat-raised-button color="warn" *ngIf="i === days.length - 1 && days.length > 1"
                      (click)="removeDay(i, stepper)"
                      type="button">
                Remove Day {{ i + 1 }}
              </button>

              <!-- Add Button - Only show on last tab and if less than max days -->
              <button mat-raised-button color="accent" *ngIf="i === days.length - 1 && days.length < maxDays"
                      (click)="addDay()"
                      type="button">
                Add Day {{ days.length + 1 }}
              </button>

              <!-- Next Button - Show if not last tab -->
              <button mat-raised-button color="primary" *ngIf="i < days.length - 1" matStepperNext type="button" [disabled]="getDayFormGroup(i).invalid">
                Next
              </button>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-center gap-2 mt-3">

            <div class="d-flex gap-2 justify-content-center">
              <!-- Submit Button - Only show on last tab -->
              <button mat-raised-button color="primary"
                      *ngIf="i === days.length - 1"
                      [disabled]="!isFormValid() || isLoading"
                      (click)="submitForm()"
                      type="button">
                {{ currentEditId ? 'Update' : 'Submit' }}
              </button>
            </div>
          </div>
        </div>
      </mat-step>
    </mat-stepper>
  </form>
</div>

<!-- Loader Spinner -->
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
